/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';

type Props = {
  children: React.ReactNode;
};

const styles = {
  verticalReset: css`
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  `,
};

const HorizontalSpacing = (props: Props) => {
  const { children } = props;

  return (
    <PageGridContainer>
      <Grid item xs={12} css={styles.verticalReset}>
        {children}
      </Grid>
    </PageGridContainer>
  );
};

export default HorizontalSpacing;
